import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

import { HeatpumpsBootstrapModule } from './lib/heatpumps.bootstrap.module';

const loadChildren = () =>
  import('./lib/heatpumps.lazy.module').then(
    (module) => module.HeatpumpsLazyModule
  );

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

const heatpumpsLazyImports: ComponentNameAndModule[] = [
  defineImport('HeatPumpOrderForm'),
  defineImport('HeatPumpWizard'),
  defineImport('HeatPumpQuestionnaire'),
];

export { heatpumpsLazyImports, HeatpumpsBootstrapModule };
